import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {observable, computed, makeObservable} from "mobx";
import type {PredictionViewModel} from "../../../../domain/full-game/models/prediction/prediction-view-model";
import {BookmakerViewModel} from "../../../../domain/common/bookmaker/models/bookmaker-view-model";

export class PredictionWidgetCardsModel extends BaseViewModel {
  @observable currentIndex: Number;

  constructor(cards: Array<PredictionViewModel>, initialIndex: Number) {
    super();

    this.cards = cards;
    this.currentIndex = initialIndex;

    makeObservable(this)
  }

  @computed get selectedCard(): PredictionViewModel {
    const selectedCard: PredictionViewModel = this.cards?.find((card: PredictionViewModel) : Boolean => card.index === this.currentIndex)

    return selectedCard;
  }

  @computed get bookmaker(): BookmakerViewModel {
    const bookmaker: BookmakerViewModel = this.hasOdds && this.selectedCard.odds.bookmaker;

    return bookmaker;
  }

  @computed get hasOdds(): Boolean {
    return this.selectedCard?.hasOdds;
  }

  @computed get isPlayerBet(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: isPlayerBet');
  }

  @computed get hasIcon(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: hasIcon');
  }

  @computed get iconSource(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: iconSource');
  }
}
